import './side-menu-layout.scss'

import { BankOutlined, BookOutlined, LogoutOutlined } from '@ant-design/icons'
import { Layout, Menu, Popconfirm, Typography } from 'antd'
import React, { ReactNode, useState } from 'react'
import { useCookies } from 'react-cookie'
import { Link } from 'react-router-dom'

import { complianceMenuItems, issuerMenuItems, menuItems } from '../../routes/route-paths'
import { authTokenCookieName, environmentCookieName } from '../../util/cookies'
import { getEnvironment } from '../../util/environment'
import { getSignInUrl } from '../../util/auth'

const { Header, Content, Sider } = Layout

interface Props {
  children: ReactNode
}

export const SideMenuLayout = ({ children }: Props) => {
  const [, , removeCookie] = useCookies([authTokenCookieName, environmentCookieName])
  const environment = getEnvironment()
  const [menuCollapsed, setMenuCollapsed] = useState(false)

  return (
    <Layout className="side-menu-layout">
      <Header className="header">
        <Typography.Title level={3}>{`Imperium Outback - ${getEnvironmentHeader(environment)}`}</Typography.Title>
      </Header>
      <Layout>
        <Sider collapsible collapsed={menuCollapsed} onCollapse={() => setMenuCollapsed(!menuCollapsed)} width={250}>
          <Menu theme="dark" mode="inline">
            {renderMenuItems(menuItems)}

            <Menu.SubMenu title="Issuers" icon={<BankOutlined />} key="sub-menu-issuers">
              {renderMenuItems(issuerMenuItems)}
            </Menu.SubMenu>

            <Menu.SubMenu title="Compliances" icon={<BookOutlined />} key="sub-menu-compliances">
              {renderMenuItems(complianceMenuItems)}
            </Menu.SubMenu>

            <Menu.Item key="logout">
              <Popconfirm
                placement="topLeft"
                title="Logout now?"
                onConfirm={() => {
                  removeCookie(authTokenCookieName)
                  window.location.href = getSignInUrl()
                }}
                okText="Yes"
                cancelText="No"
              >
                <LogoutOutlined />
                <span>Logout</span>
              </Popconfirm>
            </Menu.Item>
          </Menu>
        </Sider>
        <Content className="site-layout-background">{children}</Content>
      </Layout>
    </Layout>
  )
}
const getEnvironmentHeader = (environment: string) => {
  const environments = {
    qa: 'QA',
    demo: 'Demonstration',
    nz: 'NZ - Production',
    local: 'Local Development',
    au: 'Australia - Production',
  }

  return environments[environment || 'au']
}

const renderMenuItems = (menuItems) =>
  menuItems.map(({ route, label, icon: Icon }) => (
    <Menu.Item key={route}>
      <Link to={route}>
        <Icon />
        <span>{label}</span>
      </Link>
    </Menu.Item>
  ))
